import {
  AbsoluteContainer,
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
  Form,
  FormGroup,
  FormGroupWithIcon,
  SidePopupContainer,
} from "src/style";
import { RiCloseFill } from "react-icons/ri";
// ...existing code...
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useContext, useEffect, useState } from "react";
import ApiContext from "src/provider/API/call-service";
import { useTranslation } from "react-i18next";
import { surevyNames, surveyType } from "src/model";

type SurveyQuestionProps = {
  id?: number;
  questionType: string;
  questionText: string;
};

export const NewSurveyQuestion = ({
  close,
  refetchTriggers,
  surveyTriggerId,
  ibInstitutionCode,
  isEdit,
  initialQuestionDetails,
}: {
  close: () => void;
  refetchTriggers: () => void;
  surveyTriggerId: number;
  ibInstitutionCode: number;
  isEdit: boolean;
  initialQuestionDetails: Record<string, any>;
}) => {
  const { API } = useContext(ApiContext);
  const { t } = useTranslation();

  const [input, setInput] = useState<SurveyQuestionProps>({
    id: initialQuestionDetails && isEdit? initialQuestionDetails?.id : 0,
    questionType: initialQuestionDetails && isEdit
      ? surveyType.find((x) => x.label === initialQuestionDetails?.surveyType)
          ?.value
      : "",
    questionText: initialQuestionDetails && isEdit
      ? initialQuestionDetails?.questionText
      : "",
  });

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "questionText" && value.length > 100) return;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement> | React.FormEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    const payload = {
      ibInstitutionCode: ibInstitutionCode,
      ...(isEdit ? { id: input.id } : {}),
      questionText: input?.questionText,
      surveyType: Number(input?.questionType),
      surveyTriggerID: surveyTriggerId,
    };

    const response = await API.saveSurveyQuestion(payload);
    if (response) {
      close();
      refetchTriggers();
    }
  };

  return (
    <>
      <SidePopupContainer>
        <FlexColumn
          className="new-ads-container"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <AbsoluteContainer top="1.5" right="1.5">
            <Button
              titleSize="2"
              fontWeight="500"
              width="3.4"
              shadow="none"
              height="3.4"
              radius="0.4"
              bgColor="#ffffff"
              hoverBgColor="#FEF3F2"
              borderColor="none"
              color="#000000"
              hoverColor="#B42318"
              onClick={close}
            >
              <RiCloseFill style={{ fontSize: "2.3rem" }} />
            </Button>
          </AbsoluteContainer>
          <AppText
            color="#101828"
            textSize="1.8"
            fontWeight="700"
            fontFamily="Gilmer-Bold"
          >
            {isEdit ? t("newSurveyQuestion.editSurvey") : t("newSurveyQuestion.addNewSurvey")}
          </AppText>
          <Form onSubmit={handleSubmit}>
            <FormGroup topMargin="2">
              <label>{t("newSurveyQuestion.questionType")}</label>
              <select
                name="questionType"
                value={input.questionType || ""}
                onChange={handleInput}
                autoComplete="off"
              >
                <option value="">{t("newSurveyQuestion.selectQuestionType")}</option>

                {surveyType.map((option: any, index: number) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </FormGroup>

            <FormGroup topMargin="2">
              <label>{t("newSurveyQuestion.questionText")}</label>
              <textarea
                placeholder={t("newSurveyQuestion.enterQuestionText")}
                name="questionText"
                value={input.questionText ?? ""}
                onChange={handleInput}
                required
              />
            </FormGroup>

            <FlexRow justifyContent="flex-end" topMargin="2" gap="2">
              <Button
                type="button"
                onClick={close}
                width="12"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                bottomMargin="1"
                bgColor="#fff"
                color="#000"
                hoverColor="#0D968F"
                hoverBgColor="#fff"
                borderColor="#000"
              >
                {t("newSurveyQuestion.cancel")}
              </Button>
              <Button
                type="submit"
                width="15"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                bottomMargin="1"
                hoverColor="#0D968F"
                hoverBgColor="#fff"
                borderColor="#0D968F"
              >
                {isEdit ? t("newSurveyQuestion.updateQuestion") : t("newSurveyQuestion.addQuestion")}
              </Button>
            </FlexRow>
          </Form>
        </FlexColumn>
      </SidePopupContainer>
    </>
  );
};
